import firebase from 'firebase/app'
// rollup bundle issue with ESM import
import 'firebase/auth'
import 'firebase/firestore'

var firebaseConfig = {
  apiKey: "AIzaSyBFKFpsmDE_ADo4ZRM49Xhpqd_4XeiW3IE",
  authDomain: "ready-collect.firebaseapp.com",
  databaseURL: "https://ready-collect.firebaseio.com",
  projectId: "ready-collect",
  storageBucket: "ready-collect.appspot.com",
  messagingSenderId: "509293055193",
  appId: "1:509293055193:web:cbdcce07d38c24a10202c8",
  measurementId: "G-N3E2T2ZV6S"
}
// console.log(firebase)

firebase.initializeApp(firebaseConfig)

export const auth = firebase.auth()
export const googleProvider = new firebase.auth.GoogleAuthProvider()

export const db = firebase.firestore()
